import { render, staticRenderFns } from "./BlocEdit.vue?vue&type=template&id=52e72ab4&"
import script from "./BlocEdit.vue?vue&type=script&lang=js&"
export * from "./BlocEdit.vue?vue&type=script&lang=js&"
import style0 from "./BlocEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports